export type ObjectStorage = Record<string, any>;

export enum EditableCreditLimitEntities {
  TDMEMBER = '652fd2b6e7aa3248416b1220',
  SCBMEMBER = '62f17d2d8ae4af4b757771db',
}
